import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthGate } from './AuthGate';
import { Shell } from './Shell';
import { theme } from './theme';
import { Placeholder } from './Placeholder';
import { CategoryTree } from './pages/CategoryTree';
import { MediaLibrary } from './pages/MediaLibrary';
import { ProductEditor } from './pages/ProductEditor';
import { Products } from './pages/Products';
import { Orders } from './pages/Orders';
import { OrderDetail } from './pages/OrderDetail';
import { Vendors } from './pages/Vendors';
import { Reports } from './pages/Reports';
import { Money } from './pages/Money';
import { Coupons } from './pages/Coupons';
import { PrintLabPage } from './pages/PrintLabPage';
import { CreditBoard } from './pages/CreditBoard';
import { CreditCustomer } from './pages/CreditCustomer';
import { Loyalty } from './pages/Loyalty';
import { Crm } from './pages/Crm';
import { Notifications } from './pages/Notifications';
import { ArtistDetail } from './pages/ArtistDetail';
import { Commissions } from './pages/Commissions';
import { Ratings } from './pages/Ratings';
import { Referrals } from './pages/Referrals';
import { CrmContact } from './pages/CrmContact';
import { Reels } from './pages/Reels';
import { Banners } from './pages/Banners';
import { Artists } from './pages/Artists';

/**
 * Admin console routes. Screens land here through Phases 1 and 5; the
 * placeholders keep navigation, auth and layout honest in the meantime.
 */
export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthGate requiredRole="admin">
        <BrowserRouter>
          <Shell>
            <Routes>
              <Route path="/" element={<Navigate to="/orders" replace />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/orders/:id" element={<OrderDetail />} />
              <Route path="/catalog" element={<CategoryTree />} />
              <Route path="/catalog/products" element={<Products />} />
              <Route path="/catalog/products/:id" element={<ProductEditor />} />
              <Route path="/media" element={<MediaLibrary />} />
              <Route path="/print-lab" element={<PrintLabPage />} />
              <Route path="/vendors" element={<Vendors />} />
              <Route path="/artists" element={<Artists />} />
              <Route path="/artists/:id" element={<ArtistDetail />} />
              <Route path="/referrals" element={<Referrals />} />
              <Route path="/commissions" element={<Commissions />} />
              <Route path="/ratings" element={<Ratings />} />
              <Route path="/crm" element={<Crm />} />
              <Route path="/crm/:id" element={<CrmContact />} />
              <Route path="/reels" element={<Reels />} />
              <Route path="/banners" element={<Banners />} />
              <Route path="/money" element={<Money />} />
        <Route path="/reports" element={<Reports />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/coupons" element={<Coupons />} />
              <Route path="/loyalty" element={<Loyalty />} />
              <Route path="/loyalty/customers" element={<CreditBoard />} />
              <Route path="/loyalty/customers/:uid" element={<CreditCustomer />} />
              <Route path="*" element={<Placeholder title="Not found" phase="" />} />
            </Routes>
          </Shell>
        </BrowserRouter>
      </AuthGate>
    </ThemeProvider>
  );
}
